import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  get1sxyiyz2qwf4j as get,
  set13o7dd1nq2lc5 as set,
  Attributes2dg90yv0ot9wx as Attributes,
} from './Attributes.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function AttributesJsFn(concurrent) {
  concurrent = concurrent === VOID ? false : concurrent;
  return new (AttributesJs())();
}
var AttributesJsClass;
function AttributesJs() {
  if (AttributesJsClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.v4x_1 = LinkedHashMap().ec();
      }
      j4r(key) {
        return this.v4x_1.u4(key);
      }
      k4r(key) {
        return this.v4x_1.s4(key);
      }
      l4r(key, value) {
        // Inline function 'kotlin.collections.set' call
        this.v4x_1.x4(key, value);
      }
      n4r(key) {
        this.v4x_1.y4(key);
      }
      o4r(key, block) {
        var tmp0_safe_receiver = this.v4x_1.u4(key);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return !(tmp0_safe_receiver == null) ? tmp0_safe_receiver : THROW_CCE();
        }
        // Inline function 'kotlin.also' call
        var this_0 = block();
        // Inline function 'kotlin.collections.set' call
        this.v4x_1.x4(key, this_0);
        return this_0;
      }
      p4r() {
        return toList(this.v4x_1.v4());
      }
    }
    protoOf($).i4r = get;
    protoOf($).m4r = set;
    initMetadataForClass($, 'AttributesJs', AttributesJs, VOID, [Attributes()]);
    AttributesJsClass = $;
  }
  return AttributesJsClass;
}
//region block: exports
export {
  AttributesJsFn as AttributesJsFn25rjfgcprgprf,
};
//endregion

//# sourceMappingURL=Attributes.web.mjs.map
